<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
<!--      <sidebar-link to="/panel">-->
<!--        <i class="nc-icon nc-chart-pie-35"></i>-->
<!--        <p>Overview</p>-->
<!--      </sidebar-link>-->
      <!--<sidebar-link to="/users">-->
      <!--<i class="nc-icon nc-circle-09"></i>-->
      <!--<p>users</p>-->
      <!--</sidebar-link>-->
      <sidebar-link to="/localizations">
        <i class="nc-icon nc-planet"></i>
        <p>Localizations</p>
      </sidebar-link>
      <sidebar-link to="/devices">
        <i class="nc-icon nc-notes"></i>
        <p>Devices</p>
      </sidebar-link>
      <sidebar-link to="/users" v-if="this.isAdmin===true">
        <i class="nc-icon nc-umbrella-13"></i>
        <p>Users</p>
      </sidebar-link>
<!--      <sidebar-link to="/settings">-->
<!--        <i class="nc-icon nc-atom"></i>-->
<!--        <p>Settings</p>-->
<!--      </sidebar-link>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'

  export default {
    data() {
        return {
          mainTitle: 'Test title',
          isAdmin: localStorage.getItem('isAdmin') === 'true',
        }
    },
    mounted() {
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
